<template>
  <nav>
    <ul class="pagination justify-content-center" v-if="maxPages > 1">
      <li v-if="withPrevNext" :class="prevClass()">
        <a class="page-link" :href="path + (currentPage - 1 !== 1 ? prevQueryUrl(prevQuery, (currentPage - 1)) : prevQueryUrl(prevQuery))" @click.prevent="prev(currentPage - 1)">{{prevText}}</a>
      </li>
      <li v-for="(page, index) in pageList" :key="index + page" :class="paginationClass(page)">
        <a class="page-link" :href="path + (page !== 1 ? prevQueryUrl(prevQuery, page) : prevQueryUrl(prevQuery))" @click.prevent="changePage(page)" v-if="page !== seperator">{{page}}</a>
        <span class="page-link" v-else>{{page}}</span>
      </li>
      <li v-if="withPrevNext" :class="nextClass()">
        <a class="page-link" :href="path + (page !== 1 ? prevQueryUrl(prevQuery, (currentPage + 1)) : prevQueryUrl(prevQuery, (currentPage + 1)))" @click.prevent="next(currentPage + 1)">{{nextText}}</a>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: 'Paginator',
  data() {
    return {
      pageList: [],
      path: '',
      page: this.currentPage,
      prevQuery: {}
    }
  },
  props: {
    pages: {
      type: Array
    },
    totalPages: {
      type: Number
    },
    currentPage: {
      type: Number,
      required: true
    },
    pagesAround: {
      type: Number,
      default: 2
    },
    seperator: {
      type: String,
      default: '…'
    },
    withPrevNext: {
      type: Boolean,
      default: true
    },
    prevText: {
      type: String,
      default: '◄'
    },
    nextText: {
      type: String,
      default: '►'
    },
    currentQuery: {
      type: Object
    }
  },
  computed: {
    maxPages() {
      return this.totalPages || (this.pages && this.pages.length ? this.pages.length : 1)
    }
  },
  watch: {
    prevQuery (newVal) {
      console.log(newVal)
    }
  },
  created() {
    window.addEventListener('popstate', () => {
      if (this.$route.query.page) {
        this.page = parseInt(this.$route.query.page) || 1
      } else {
        this.page = 1
      }
      this.changePage(this.page)
    })
  },
  mounted() {
    this.prevQuery = JSON.parse(JSON.stringify(this.$route.query))
    this.path = this.$route.path

    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page)
    } else {
      this.page = 1
    }
    this.makePageList()
    this.changePage(this.page)
  },
  methods: {
    makePageList() {
      if (this.maxPages < this.pagesAround * 2 + 6) {
        this.add(1, this.maxPages + 1)
      } else if (this.currentPage < this.pagesAround * 2 + 1) {
        this.add(1, this.pagesAround * 2 + 4)
        this.last()
      } else if (this.currentPage > this.maxPages - this.pagesAround * 2) {
        this.first()
        this.add(this.maxPages - this.pagesAround * 2 - 2, this.maxPages + 1)
      } else {
        this.first()
        this.add(this.currentPage - this.pagesAround, this.currentPage + this.pagesAround + 1)
        this.last()
      }
    },
    add(start, finish) {
      for (let i = start; i < finish; i++) {
        this.pageList.push(i)
      }
    },
    first() {
      this.pageList.push(1)
      this.pageList.push(this.seperator)
    },
    last() {
      this.pageList.push(this.seperator)
      this.pageList.push(this.maxPages)
    },
    prev(page) {
      if (page < 1) {
        page = 1
      }
      this.changePage(page)
    },
    next(page) {
      if (page > this.maxPages) {
        page = this.maxPages
      }
      this.changePage(page)
    },
    changePage(goToPage) {
      if (this.prevQuery && this.prevQuery.page) delete this.prevQuery.page

      if (goToPage !== 1) {
        this.prevQuery['page'] = goToPage
      }

      this.$router.push({ name: this.$route.name, query: this.prevQuery })
      if (goToPage === this.currentPage) return
      this.$emit('update:currentPage', goToPage)
    },
    paginationClass(page) {
      return {
        'page-item': true,
        active: this.currentPage === page,
        disabled: page === this.seperator
      }
    },
    prevClass() {
      return {
        'page-item': true,
        disabled: this.currentPage === 1
      }
    },
    nextClass() {
      return {
        'page-item': true,
        disabled: this.currentPage === this.maxPages
      }
    },
    setQuery(q) {
      this.prevQuery = q
    },
    prevQueryUrl(json, page) {
      let url = '?'
      if (json) {
        url += Object.keys(json).map(function (k) {
          if (k !== 'page') {
            return encodeURIComponent(k) + '=' + encodeURIComponent(json[k])
          }
        }).join('&')
      }
      if (page) {
        url += (url.length > 1 ? '&' : '') + 'page=' + page
      }

      return url.length > 1 ? url : ''
    }
  }
}

</script>
